
window.addEventListener("DOMContentLoaded", function () {
	$.datepicker.regional['fr'] = {
		clearText: 'Effacer',
		clearStatus: '',
		closeText: 'Fermer', 
		closeStatus: 'Fermer sans modifier',
		prevText: '&lt;Préc', 
		prevStatus: 'Voir le mois précédent',
		nextText: 'Suiv&gt;', 
		nextStatus: 'Voir le mois suivant',
		currentText: 'Courant', 
		currentStatus: 'Voir le mois courant',
		monthNames: ['Janvier','Février','Mars','Avril','Mai','Juin','Juillet','Août','Septembre','Octobre','Novembre','Décembre'],
		monthNamesShort: ['Jan','Fév','Mar','Avr','Mai','Jun','Jul','Aoû','Sep','Oct','Nov','Déc'],
		monthStatus: 'Voir un autre mois', 
		yearStatus: 'Voir un autre année',
		weekHeader: 'Sm', 
		weekStatus: '',
		dayNames: ['Dimanche','Lundi','Mardi','Mercredi','Jeudi','Vendredi','Samedi'],
		dayNamesShort: ['Dim','Lun','Mar','Mer','Jeu','Ven','Sam'],
		dayNamesMin: ['D','L','M','M','J','V','S'],
		dayStatus: 'Utiliser DD comme premier jour de la semaine', 
		dateStatus: 'Choisir le DD, MM d',
		dateFormat: 'dd/mm/yy',
		firstDay: 1, 
		initStatus: 'Choisir la date', 
		isRTL: false
	};
});
